'use strict';

var $ = require('jquery'),
  _ = require('underscore'),
  mediator = require('../../js/mediator'),
  utilities = require('../../js/utilities'),
  ModalView = require('../../js/components/ModalView'),
  productQuantityRestrictionTemplate = require('../../tmpl/client/modal/productQuantityRestriction.hbs'),
  FormView = require('../Form/FormView'),
  config = require('../../js/config'),
  globalisation = require('../../utilities/globalisation'),
  ProductQuantityRestrictionModalView;
ProductQuantityRestrictionModalView = ModalView.extend({
  template: productQuantityRestrictionTemplate,

  events: {
    'keyup .ProductPurchase-quantity': 'updatePriceDisplay'
  },

  initialize: function() {

    ProductQuantityRestrictionModalView.__super__.initialize.apply(this, arguments);

    mediator.on(config.events.cart.quantityRestriction, this.open);

    this.addProductQuantityValidatorMethod();
  },


  updatePriceDisplay: function() {
    var $totalLabel = this.$('.product-quantity-total');
    var $totalPrice = this.$('.product-quantity-total-price');

    this.modalData.quantity = utilities.parseQuantity(this.$('.Modal-input').val());
    var total = utilities.calculateLineItemPrice(
      this.modalData.quantity,
      this.modalData.model
    );

    if (isNaN(total)) {
      $totalLabel.removeClass(config.classes.isVisible);
      $totalPrice.text('');
    } else {
      $totalLabel.addClass(config.classes.isVisible);
      $totalPrice.html(globalisation.formatCurrency(total));
    }
  },

  addProductQuantityValidatorMethod: function() {
    $.validator.addMethod('productQuantity', function(quantity, element, model) {
      var total = utilities.calculateLineItemPrice(
        utilities.parseQuantity(quantity),
        model
      );
      return !isNaN(total);
    });
  },

  // Get the reason for the error dialog to have been shown
  getErrorReason: function(addedProduct) {
    if (!utilities.isInteger(addedProduct.quantity)) {
      addedProduct.reason = 'modalInvalidQuantityError';
    } else if (addedProduct.quantity > addedProduct.model.quantity) {
      addedProduct.reason = 'modalMaxQuantityReachedError';
    } else if (addedProduct.quantity < addedProduct.model.orderMinimumQuantity) {
      addedProduct.reason = 'modalMinQuantityNotReachedError';
    } else if (addedProduct.quantity % addedProduct.model.orderIncrement !== 0) {
      addedProduct.reason = 'modalQuantityNotInIncrementsOfError';
    } else {
      addedProduct.reason = 'modalNoQuantityError';
    }
  },

  /**
   * Open the modal.
   *
   * @param {AddedProduct[]} addedProducts
   */
  open: function(addedProducts) {
    // The modal restriction dialog should only deal with one product
    let addedProduct = addedProducts[0];
    this.getErrorReason(addedProduct);

    // Blank invalid quantities for display
    if (isNaN(addedProduct.quantity)) {
      addedProduct.quantity = '';
    }

    ProductQuantityRestrictionModalView.__super__.open.call(this, addedProduct);
  },

  createFormView: function() {
    return new FormView({
      el: this.$('form'),
      errorPlacement: _.bind(this.onError, this)
    });
  },

  updateErrorReason: function() {
    this.$('.Modal-header').text(globalisation.pluraliseAndTranslate('shoppingCart', this.modalData.reason, this.modalData.model));
  },

  onError: function() {
    this.modalData.quantity = parseInt(this.$('.Modal-input').val(), 10);
    this.getErrorReason(this.modalData);
    this.updateErrorReason();
  },

  onOpen: function() {
    var $input = this.$('.Modal-input'),
      addedProduct = this.modalData;

    // Add range validation
    this.formView = this.createFormView();

    $input.rules('add', {
      productQuantity: {
        orderIncrement: addedProduct.model.orderIncrement,
        priceBands: addedProduct.model.priceBands,
        quantity: addedProduct.model.quantity,
        orderMinimumQuantity: addedProduct.model.orderMinimumQuantity
      }
    });

    // When form is submitted
    this.formView.$el.on('submit', this.onConfirm);

    // Focus the input when opened but not on iOS coz it's buggy and causes the modal to jump & disappear
    if (!/iPad|iPhone|iPod/g.test(navigator.userAgent)) {
      this.focusInput();
    }

  },

  // Focus the end of the input
  focusInput: function() {
    var $input = this.$('.Modal-input');

    $input.focus();

    if ($input.get(0).setSelectionRange) {
      var len = $input.val().length * 2;
      $input.get(0).setSelectionRange(len, len);
    } else {
      $input.val($input.val());
    }
  },

  // Submit logic
  onConfirm: function() {
    // If we are valid
    this.formView.validator.form();
    if (!this.formView.validator.numberOfInvalids()) {
      // Update the item data
      this.modalData.quantity = utilities.parseQuantity(this.$('.Modal-input').val());
      mediator.trigger(config.events.cart.add, [this.modalData]);
      this.close('confirmation');
    }
  }
});

module.exports = ProductQuantityRestrictionModalView;



// WEBPACK FOOTER //
// ./assets/components/Cart/ProductQuantityRestrictionModalView.js